/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import Icon from '@/Components/UI/Icon/Icon';

const ViewRow = ({ view, onSelectViewChange, disableSelect }) => {
  return (
    <div
      data-cy={`select-view-${view?.label}`}
      className='flex items-center justify-between cursor-default'
      onClick={() => {
        if (disableSelect) {
          return;
        }
        onSelectViewChange(view);
      }}
    >
      <div className='flex items-center w-full h-8 gap-2 px-2 py-1 rounded hover:bg-shadow-100 hover:bg-opacity-40'>
        <div className='w-4'>
          <Icon
            name={view?.isEnabled ? 'lightning' : 'lightning-slash'}
            color={view?.isEnabled ? '#F2CA00' : '#d6d6d6'}
            weight={view?.isEnabled ? 'duotone' : 'regular'}
          />
        </div>
        <div className='truncate'>{view?.label}</div>
      </div>
    </div>
  );
};

export default ViewRow;
